import React from "react";
import { genURL, gengetURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
require('../_css/PopUpARInvDebt.css');

export default class PopUpOther extends React.Component {
    state = {
        type: this.props.type,
        col: [],
        rows: [],
        Htext: "",
        SHtype: 3,
        casschkbox: "far fa-square",
        casschkboxs: false,
        ckbox_length: 0,
    }

    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event) => {
        var dataArray = [];
        let Url = "";
        if (event === "ARInvDebt") {
            Url = "CSV_ARINVBAL/GET?Arcode=" + this.props.ARCODE + "&Top=" + 10;
        } else if (event.key === "Enter") {
            Url = "CSV_ARINVBAL/GET?Arcode=" + this.props.ARCODE + "&Top=" + 10;
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
        console.log(genURL(Url));
        axios.get(genURL(Url), { timeout: 60000 }).then(res => {
            if (res.data.length >= 1) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        number: i + 1,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFTAXNO: res.data[i].REFTAXNO,
                        REFDOCDATE: this.GetformatTimestamp(res.data[i].REFDOCDATE),
                        CREDITCODE: res.data[i].CREDITCODE,
                        REFDUEDATE: this.GetformatTimestamp(res.data[i].REFDUEDATE),
                        TRANSNAME: res.data[i].TRANSNAME,
                        department: res.data[i].department,
                        DEBTAMOUNT: res.data[i].DEBTAMOUNT,
                        DEBTBALANCE: res.data[i].DEBTBALANCE,
                        REMARK: res.data[i].REMARK,
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                        SELFLAG: res.data[i].SELFLAG,
                        SELFLAG2: res.data[i].SELFLAG2,
                        usercode: res.data[i].usercode,
                        project: res.data[i].project,
                        allocatecode: res.data[i].allocatecode,
                        sitecode: res.data[i].sitecode,
                        REFTAXAMOUNT: res.data[i].REFTAXAMOUNT,
                        PAYTAXAMOUNT: res.data[i].PAYTAXAMOUNT,
                        INTEREST_RATE: res.data[i].INTEREST_RATE,
                        PAYINTEREST: res.data[i].PAYINTEREST,
                        ARCODE: res.data[i].ARCODE,
                        DOCGROUP: res.data[i].DOCGROUP,
                        PAYBILLAMOUNT: res.data[i].PAYBILLAMOUNT,
                        PREPAYAMOUNT: res.data[i].PREPAYAMOUNT,
                        FACTORING: res.data[i].FACTORING,
                        REFAMOUNT: res.data[i].REFAMOUNT,
                        DEPARTNAME: res.data[i].DEPARTNAME,
                        BILLEXCHANGERATE: res.data[i].BILLEXCHANGERATE,
                        CURRENCYCODE: res.data[i].CURRENCYCODE,
                        CURRNAME: res.data[i].CURRNAME,
                        TRANSREFDOCNO: res.data[i].TRANSREFDOCNO,
                        SB: "0"
                    }
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        }).catch(error => {
            console.log(error);
        });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        var dataArray = [];
        var Url
        var Arcode = this.props.ARCODE
        switch (this.props.type) {

            case "ARInvDebt":
                this.setState({ sh_Deposit: true });
                Url = "CSV_ARINVBAL/GET?Arcode=" + Arcode.trim() + "&top=" + 50;
                console.log(genURL(Url));
                axios.get(genURL(Url), { timeout: 60000 }).then(res => {
                    console.log(res.data.length);
                    if (res.data.length >= 1) {
                        for (let ci = 0; ci < res.data.length; ci++) {
                            dataArray[ci] = {
                                number: ci + 1,
                                REFDOCNO: res.data[ci].REFDOCNO,
                                REFTAXNO: res.data[ci].REFTAXNO,
                                REFDOCDATE: this.GetformatTimestamp(res.data[ci].REFDOCDATE),
                                CREDITCODE: res.data[ci].CREDITCODE,
                                REFDUEDATE: this.GetformatTimestamp(res.data[ci].REFDUEDATE),
                                TRANSNAME: res.data[ci].TRANSNAME,
                                department: res.data[ci].department,
                                DEBTAMOUNT: res.data[ci].DEBTAMOUNT,
                                DEBTBALANCE: res.data[ci].DEBTBALANCE,
                                REMARK: res.data[ci].REMARK,
                                REFDOCTYPE: res.data[ci].REFDOCTYPE,
                                SELFLAG: res.data[ci].SELFLAG,
                                SELFLAG2: res.data[ci].SELFLAG2,
                                usercode: res.data[ci].usercode,
                                project: res.data[ci].project,
                                allocatecode: res.data[ci].allocatecode,
                                sitecode: res.data[ci].sitecode,
                                REFTAXAMOUNT: res.data[ci].REFTAXAMOUNT,
                                PAYTAXAMOUNT: res.data[ci].PAYTAXAMOUNT,
                                INTEREST_RATE: res.data[ci].INTEREST_RATE,
                                PAYINTEREST: res.data[ci].PAYINTEREST,
                                ARCODE: res.data[ci].ARCODE,
                                DOCGROUP: res.data[ci].DOCGROUP,
                                PAYBILLAMOUNT: res.data[ci].PAYBILLAMOUNT,
                                PREPAYAMOUNT: res.data[ci].PREPAYAMOUNT,
                                FACTORING: res.data[ci].FACTORING,
                                REFAMOUNT: res.data[ci].REFAMOUNT,
                                DEPARTNAME: res.data[ci].DEPARTNAME,
                                BILLEXCHANGERATE: res.data[ci].BILLEXCHANGERATE,
                                CURRENCYCODE: res.data[ci].CURRENCYCODE,
                                CURRNAME: res.data[ci].CURRNAME,
                                TRANSREFDOCNO: res.data[ci].TRANSREFDOCNO,
                                SB: "0"
                            }
                        }
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    } else {
                        dataArray = [];
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    }
                }).catch(error => {
                    console.log(error);
                });
                this.setState({ col: dataArray, Htext: "เลือกเอกสารตั้งหนี้คงค้าง" });
                break;
            default: break;
        }
    }
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        // console.log(rowIndex)
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }

    Update_Status = (Row, Status) => {
        var dataArray
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].REFDOCNO; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                dataArray = this.state.rows;

                for (var i1 = 0; i1 < this.state.rows.length && this.state.rows[i1].REFDOCNO; i1++) {
                    dataArray[i1].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i2 = 0; i2 < this.state.rows.length && this.state.rows[i2].REFDOCNO; i2++) {
                if (this.state.rows[i2].SB === 1) {
                    sb_length = sb_length + 1;
                }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
    chkdata = (data) => {
        var redata = "";
        if (data !== "null") {
            redata = data;
        }
        if (typeof data === "undefined") {
            redata = ""
        }
        return redata;
    }
    onSelectRow = (data, col, id) => {
        if (col > 1) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            //------------------------
            var Data = [];
            var sb_length = 0;
            var j = 0;

            for (var i = 0; i < this.state.rows.length; i++) {
                if (this.state.rows[i].SB === "1") {
                    console.log(this.state.rows[i].SB, "Dddd");
                    sb_length = sb_length + 1;
                    Data[j] = {
                        REFDOCNO: this.state.rows[i].REFDOCNO,
                        REFTAXNO: this.state.rows[i].REFTAXNO,
                        REFDOCDATE: this.state.rows[i].REFDOCDATE,
                        CREDITCODE: this.state.rows[i].CREDITCODE,
                        REFDUEDATE: this.state.rows[i].REFDUEDATE,
                        TRANSNAME: this.state.rows[i].TRANSNAME,
                        department: this.state.rows[i].department,
                        DEBTAMOUNT: this.state.rows[i].DEBTAMOUNT,
                        DEBTBALANCE: this.state.rows[i].DEBTBALANCE,
                        REMARK: this.state.rows[i].REMARK,
                        REFDOCTYPE: this.state.rows[i].REFDOCTYPE,
                        SELFLAG: this.state.rows[i].SELFLAG,
                        SELFLAG2: this.state.rows[i].SELFLAG2,
                        usercode: this.state.rows[i].usercode,
                        project: this.state.rows[i].project,
                        allocatecode: this.state.rows[i].allocatecode,
                        sitecode: this.state.rows[i].sitecode,
                        REFTAXAMOUNT: this.state.rows[i].REFTAXAMOUNT,
                        PAYTAXAMOUNT: this.state.rows[i].PAYTAXAMOUNT,
                        INTEREST_RATE: this.state.rows[i].INTEREST_RATE,
                        PAYINTEREST: this.state.rows[i].PAYINTEREST,
                        ARCODE: this.state.rows[i].ARCODE,
                        ARNAME: this.state.rows[i].ARNAME,
                        DOCGROUP: this.state.rows[i].DOCGROUP,
                        PAYBILLAMOUNT: this.state.rows[i].PAYBILLAMOUNT,
                        PREPAYAMOUNT: this.state.rows[i].PREPAYAMOUNT,
                        FACTORING: this.state.rows[i].FACTORING,
                        REFAMOUNT: this.state.rows[i].REFAMOUNT,
                        DEPARTNAME: this.state.rows[i].DEPARTNAME,
                        BILLEXCHANGERATE: this.state.rows[i].BILLEXCHANGERATE,
                        CURRENCYCODE: this.state.rows[i].CURRENCYCODE,
                        CURRNAME: this.state.rows[i].CURRNAME,
                        TRANSREFDOCNO: this.state.rows[i].TRANSREFDOCNO,
                        REFINTEREST: this.state.rows[i].REFINTEREST
                    }
                    j = j + 1;
                }
            }

            /*//////////////////////////////  ส่งกลับหน้า    PSReceipt //////////////////////////////////////////////////////*/
            console.log(Data.length, "===", sb_length);

            if (Data.length === sb_length) {

                for (var i1 = 0; i1 < Data.length; i1++) {
                    var redata =
                        this.chkdata(Data[i1].REFDOCNO) + "|" +
                        this.chkdata(Data[i1].REFTAXNO) + "|" +
                        this.chkdata(Data[i1].REFDOCDATE) + "|" +
                        this.chkdata(Data[i1].CREDITCODE) + "|" +
                        this.chkdata(Data[i1].REFDUEDATE) + "|" +
                        this.chkdata(Data[i1].TRANSNAME) + "|" +
                        this.chkdata(Data[i1].department) + "|" +
                        this.chkdata(Data[i1].DEBTAMOUNT) + "|" +
                        this.chkdata(Data[i1].DEBTBALANCE) + "|" +
                        this.chkdata(Data[i1].REMARK) + "|" +
                        this.chkdata(Data[i1].REFDOCTYPE) + "|" +
                        this.chkdata(Data[i1].SELFLAG) + "|" +
                        this.chkdata(Data[i1].SELFLAG2) + "|" +
                        this.chkdata(Data[i1].usercode) + "|" +
                        this.chkdata(Data[i1].project) + "|" +
                        this.chkdata(Data[i1].allocatecode) + "|" +
                        this.chkdata(Data[i1].sitecode) + "|" +
                        this.chkdata(Data[i1].REFTAXAMOUNT) + "|" +
                        this.chkdata(Data[i1].PAYTAXAMOUNT) + "|" +
                        this.chkdata(Data[i1].INTEREST_RATE) + "|" +
                        this.chkdata(Data[i1].PAYINTEREST) + "|" +
                        this.chkdata(Data[i1].ARCODE) + "|" +
                        this.chkdata(Data[i1].ARNAME) + "|" +
                        this.chkdata(Data[i1].DOCGROUP) + "|" +
                        this.chkdata(Data[i1].PAYBILLAMOUNT) + "|" +
                        this.chkdata(Data[i1].PREPAYAMOUNT) + "|" +
                        this.chkdata(Data[i1].FACTORING) + "|" +
                        this.chkdata(Data[i1].REFAMOUNT) + "|" +
                        this.chkdata(Data[i1].DEPARTNAME) + "|" +
                        this.chkdata(Data[i1].BILLEXCHANGERATE) + "|" +
                        this.chkdata(Data[i1].CURRENCYCODE) + "|" +
                        this.chkdata(Data[i1].CURRNAME) + "|" +
                        this.chkdata(Data[i1].TRANSREFDOCNO) + "|" +
                        this.chkdata(Data[i1].REFINTEREST)

                    console.log(redata);

                    this.props.Get_PopUpOther3(redata);
                }
            }
        }
    }
    onSubmit = (e) => {
        var Data = [];
        var sb_length = 0;
        var j = 0;
        for (var i = 0; i < this.state.rows.length; i++) {
            if (this.state.rows[i].SB === "1") {
                console.log(this.state.rows[i].SB, "Dddd");
                sb_length = sb_length + 1;
                Data[j] = {
                    REFDOCNO: this.state.rows[i].REFDOCNO,
                    REFTAXNO: this.state.rows[i].REFTAXNO,
                    REFDOCDATE: this.state.rows[i].REFDOCDATE,
                    CREDITCODE: this.state.rows[i].CREDITCODE,
                    REFDUEDATE: this.state.rows[i].REFDUEDATE,
                    TRANSNAME: this.state.rows[i].TRANSNAME,
                    department: this.state.rows[i].department,
                    DEBTAMOUNT: this.state.rows[i].DEBTAMOUNT,
                    DEBTBALANCE: this.state.rows[i].DEBTBALANCE,
                    REMARK: this.state.rows[i].REMARK,
                    REFDOCTYPE: this.state.rows[i].REFDOCTYPE,
                    SELFLAG: this.state.rows[i].SELFLAG,
                    SELFLAG2: this.state.rows[i].SELFLAG2,
                    usercode: this.state.rows[i].usercode,
                    project: this.state.rows[i].project,
                    allocatecode: this.state.rows[i].allocatecode,
                    sitecode: this.state.rows[i].sitecode,
                    REFTAXAMOUNT: this.state.rows[i].REFTAXAMOUNT,
                    PAYTAXAMOUNT: this.state.rows[i].PAYTAXAMOUNT,
                    INTEREST_RATE: this.state.rows[i].INTEREST_RATE,
                    PAYINTEREST: this.state.rows[i].PAYINTEREST,
                    ARCODE: this.state.rows[i].ARCODE,
                    ARNAME: this.state.rows[i].ARNAME,
                    DOCGROUP: this.state.rows[i].DOCGROUP,
                    PAYBILLAMOUNT: this.state.rows[i].PAYBILLAMOUNT,
                    PREPAYAMOUNT: this.state.rows[i].PREPAYAMOUNT,
                    FACTORING: this.state.rows[i].FACTORING,
                    REFAMOUNT: this.state.rows[i].REFAMOUNT,
                    DEPARTNAME: this.state.rows[i].DEPARTNAME,
                    BILLEXCHANGERATE: this.state.rows[i].BILLEXCHANGERATE,
                    CURRENCYCODE: this.state.rows[i].CURRENCYCODE,
                    CURRNAME: this.state.rows[i].CURRNAME,
                    TRANSREFDOCNO: this.state.rows[i].TRANSREFDOCNO,
                    REFINTEREST: this.state.rows[i].REFINTEREST
                }
                j = j + 1;
            }
        }

        /*//////////////////////////////  ส่งกลับหน้า    PSReceipt //////////////////////////////////////////////////////*/
        console.log(Data.length, "===", sb_length);

        if (Data.length === sb_length) {

            for (var i1 = 0; i1 < Data.length; i1++) {
                var redata =
                    this.chkdata(Data[i1].REFDOCNO) + "|" +
                    this.chkdata(Data[i1].REFTAXNO) + "|" +
                    this.chkdata(Data[i1].REFDOCDATE) + "|" +
                    this.chkdata(Data[i1].CREDITCODE) + "|" +
                    this.chkdata(Data[i1].REFDUEDATE) + "|" +
                    this.chkdata(Data[i1].TRANSNAME) + "|" +
                    this.chkdata(Data[i1].department) + "|" +
                    this.chkdata(Data[i1].DEBTAMOUNT) + "|" +
                    this.chkdata(Data[i1].DEBTBALANCE) + "|" +
                    this.chkdata(Data[i1].REMARK) + "|" +
                    this.chkdata(Data[i1].REFDOCTYPE) + "|" +
                    this.chkdata(Data[i1].SELFLAG) + "|" +
                    this.chkdata(Data[i1].SELFLAG2) + "|" +
                    this.chkdata(Data[i1].usercode) + "|" +
                    this.chkdata(Data[i1].project) + "|" +
                    this.chkdata(Data[i1].allocatecode) + "|" +
                    this.chkdata(Data[i1].sitecode) + "|" +
                    this.chkdata(Data[i1].REFTAXAMOUNT) + "|" +
                    this.chkdata(Data[i1].PAYTAXAMOUNT) + "|" +
                    this.chkdata(Data[i1].INTEREST_RATE) + "|" +
                    this.chkdata(Data[i1].PAYINTEREST) + "|" +
                    this.chkdata(Data[i1].ARCODE) + "|" +
                    this.chkdata(Data[i1].ARNAME) + "|" +
                    this.chkdata(Data[i1].DOCGROUP) + "|" +
                    this.chkdata(Data[i1].PAYBILLAMOUNT) + "|" +
                    this.chkdata(Data[i1].PREPAYAMOUNT) + "|" +
                    this.chkdata(Data[i1].FACTORING) + "|" +
                    this.chkdata(Data[i1].REFAMOUNT) + "|" +
                    this.chkdata(Data[i1].DEPARTNAME) + "|" +
                    this.chkdata(Data[i1].BILLEXCHANGERATE) + "|" +
                    this.chkdata(Data[i1].CURRENCYCODE) + "|" +
                    this.chkdata(Data[i1].CURRNAME) + "|" +
                    this.chkdata(Data[i1].TRANSREFDOCNO) + "|" +
                    this.chkdata(Data[i1].REFINTEREST)

                console.log(redata);

                this.props.Get_PopUpOther3(redata);
            }
        }
    }
    render() {
        return (
            <div className='popup' /* style={{ 'z-index': '100' }} */ >
                <div className='popup_inner' /* className='popup_inner_arinvdebt divBox' */>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-search "/* fas fa-at */ > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>

                    <div class="panel-body divTable" align="right">

                        {/* {this.state.sh_Deposit === true ?
                            <div class=" form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                <input id="id1" type="text" class="form-control" ref="Search" onKeyPress={this.Get_Data.bind(null)} onBlur={this.Get_Data.bind(null, "ARInvDebt")} />
                                <span id="iconsearch" class="input-group-addon icon"><i class="fas fa-search"></i></span>
                            </div>
                            : null
                        } */}
                        <div >
                            <BootstrapTable
                                data={this.state.rows}
                                // pagination
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="520"
                                hover condensed search={true}>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="4%" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="5%" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i style={{ fontSize: '20px' }} class={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="13%" dataField='REFDOCNO' > เอกสารตั้งหนี้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="13%" dataField='REFTAXNO' > ใบกำกับภาษี </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFDOCDATE' > วันที่ตั้งหนี้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='CREDITCODE' dataAlign="left" > เครดิต </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFDUEDATE' dataAlign="left"> ครบกำหนด </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='TRANSNAME' dataAlign="left"> รายวัน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='department' dataAlign="left"> แผนก </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="7%" dataField='DEBTAMOUNT' dataAlign="right"> ยอดตั้งหนี้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="8%" dataField='DEBTBALANCE' dataAlign="right"> ยอดคงค้าง </TableHeaderColumn>
                                <TableHeaderColumn dataField='SELFLAG' hidden> SELFLAG </TableHeaderColumn>
                                <TableHeaderColumn dataField='SELFLAG2' hidden> SELFLAG2 </TableHeaderColumn>
                                <TableHeaderColumn dataField='usercode' hidden> usercode </TableHeaderColumn>
                                <TableHeaderColumn dataField='project' hidden> project </TableHeaderColumn>
                                <TableHeaderColumn dataField='allocatecode' hidden> allocatecode </TableHeaderColumn>
                                <TableHeaderColumn dataField='sitecode' hidden> sitecode </TableHeaderColumn>
                                <TableHeaderColumn dataField='REFTAXAMOUNT' hidden> REFTAXAMOUNT </TableHeaderColumn>
                                <TableHeaderColumn dataField='PAYTAXAMOUNT' hidden> PAYTAXAMOUNT </TableHeaderColumn>
                                <TableHeaderColumn dataField='INTEREST_RATE' hidden> INTEREST_RATE </TableHeaderColumn>
                                <TableHeaderColumn dataField='REFINTEREST' hidden> REFINTEREST </TableHeaderColumn>
                                <TableHeaderColumn dataField='PAYINTEREST' hidden> PAYINTEREST </TableHeaderColumn>
                                <TableHeaderColumn dataField='REFDOCTYPE' hidden > REFDOCTYPE </TableHeaderColumn>
                                <TableHeaderColumn dataField='ARCODE' hidden> ARCODE </TableHeaderColumn>
                                <TableHeaderColumn dataField='DOCGROUP' hidden> DOCGROUP </TableHeaderColumn>
                                <TableHeaderColumn dataField='PAYBILLAMOUNT' hidden> PAYBILLAMOUNT </TableHeaderColumn>
                                <TableHeaderColumn dataField='PREPAYAMOUNT' hidden> PREPAYAMOUNT </TableHeaderColumn>
                                <TableHeaderColumn dataField='FACTORING' hidden> FACTORING </TableHeaderColumn>
                                <TableHeaderColumn dataField='REFAMOUNT' hidden> REFAMOUNT </TableHeaderColumn>
                                <TableHeaderColumn dataField='DEPARTNAME' hidden> DEPARTNAME </TableHeaderColumn>
                                <TableHeaderColumn dataField='BILLEXCHANGERATE' hidden> BILLEXCHANGERATE </TableHeaderColumn>
                                <TableHeaderColumn dataField='CURRENCYCODE' hidden> CURRENCYCODE </TableHeaderColumn>
                                <TableHeaderColumn dataField='CURRNAME' hidden> CURRNAME </TableHeaderColumn>
                                <TableHeaderColumn dataField='REMARK' hidden> REMARK </TableHeaderColumn>
                                <TableHeaderColumn dataField='TRANSREFDOCNO' hidden> TRANSREFDOCNO </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <button class="PUSDbtn" onClick={this.onSubmit}>
                            <i class="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}